module.exports = __webpack_public_path__ + "img/icons8-suitcase-64.ea6c9025.svg";